/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanBaseResponse } from '../models/boolean-base-response';
import { ExerciseDto } from '../models/exercise-dto';
import { ExerciseDtoBaseResponse } from '../models/exercise-dto-base-response';
import { ExerciseDtoPagedResponse } from '../models/exercise-dto-paged-response';

@Injectable({
  providedIn: 'root',
})
export class ClinicExerciseLibraryService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesBodyPartListGet
   */
  static readonly ApiClinicExerciseLibraryExercisesBodyPartListGetPath = '/api/ClinicExerciseLibrary/exercises/BodyPartList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesBodyPartListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodyPartListGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesBodyPartListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesBodyPartListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodyPartListGet$Plain(params?: {
  }): Observable<Array<string>> {

    return this.apiClinicExerciseLibraryExercisesBodyPartListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesBodyPartListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodyPartListGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesBodyPartListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesBodyPartListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodyPartListGet$Json(params?: {
  }): Observable<Array<string>> {

    return this.apiClinicExerciseLibraryExercisesBodyPartListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesTargetListGet
   */
  static readonly ApiClinicExerciseLibraryExercisesTargetListGetPath = '/api/ClinicExerciseLibrary/exercises/TargetList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesTargetListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetListGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesTargetListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesTargetListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetListGet$Plain(params?: {
  }): Observable<Array<string>> {

    return this.apiClinicExerciseLibraryExercisesTargetListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesTargetListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetListGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesTargetListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesTargetListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetListGet$Json(params?: {
  }): Observable<Array<string>> {

    return this.apiClinicExerciseLibraryExercisesTargetListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesEquipmentListGet
   */
  static readonly ApiClinicExerciseLibraryExercisesEquipmentListGetPath = '/api/ClinicExerciseLibrary/exercises/EquipmentList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesEquipmentListGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentListGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesEquipmentListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesEquipmentListGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentListGet$Plain(params?: {
  }): Observable<Array<string>> {

    return this.apiClinicExerciseLibraryExercisesEquipmentListGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesEquipmentListGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentListGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<Array<string>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesEquipmentListGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<string>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesEquipmentListGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentListGet$Json(params?: {
  }): Observable<Array<string>> {

    return this.apiClinicExerciseLibraryExercisesEquipmentListGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<string>>) => r.body as Array<string>)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesEquipmentEquipmentGet
   */
  static readonly ApiClinicExerciseLibraryExercisesEquipmentEquipmentGetPath = '/api/ClinicExerciseLibrary/exercises/equipment/{equipment}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Plain$Response(params: {
    equipment: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesEquipmentEquipmentGetPath, 'get');
    if (params) {
      rb.path('equipment', params.equipment, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Plain(params: {
    equipment: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Json$Response(params: {
    equipment: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesEquipmentEquipmentGetPath, 'get');
    if (params) {
      rb.path('equipment', params.equipment, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Json(params: {
    equipment: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesEquipmentEquipmentGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesBodypartBodyPartGet
   */
  static readonly ApiClinicExerciseLibraryExercisesBodypartBodyPartGetPath = '/api/ClinicExerciseLibrary/exercises/bodypart/{bodyPart}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Plain$Response(params: {
    bodyPart: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesBodypartBodyPartGetPath, 'get');
    if (params) {
      rb.path('bodyPart', params.bodyPart, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Plain(params: {
    bodyPart: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Json$Response(params: {
    bodyPart: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesBodypartBodyPartGetPath, 'get');
    if (params) {
      rb.path('bodyPart', params.bodyPart, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Json(params: {
    bodyPart: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesBodypartBodyPartGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesIdGet
   */
  static readonly ApiClinicExerciseLibraryExercisesIdGetPath = '/api/ClinicExerciseLibrary/exercises/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdGet$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdGet$Plain(params: {
    id: number;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdGet$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesIdGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdGet$Json(params: {
    id: number;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesIdPut
   */
  static readonly ApiClinicExerciseLibraryExercisesIdPutPath = '/api/ClinicExerciseLibrary/exercises/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesIdPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesIdPut$Plain$Response(params: {
    id: number;
    body?: ExerciseDto
  }): Observable<StrictHttpResponse<ExerciseDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExerciseDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesIdPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesIdPut$Plain(params: {
    id: number;
    body?: ExerciseDto
  }): Observable<ExerciseDtoBaseResponse> {

    return this.apiClinicExerciseLibraryExercisesIdPut$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ExerciseDtoBaseResponse>) => r.body as ExerciseDtoBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesIdPut$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesIdPut$Json$Response(params: {
    id: number;
    body?: ExerciseDto
  }): Observable<StrictHttpResponse<ExerciseDtoBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesIdPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExerciseDtoBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesIdPut$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesIdPut$Json(params: {
    id: number;
    body?: ExerciseDto
  }): Observable<ExerciseDtoBaseResponse> {

    return this.apiClinicExerciseLibraryExercisesIdPut$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ExerciseDtoBaseResponse>) => r.body as ExerciseDtoBaseResponse)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesIdDelete
   */
  static readonly ApiClinicExerciseLibraryExercisesIdDeletePath = '/api/ClinicExerciseLibrary/exercises/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesIdDelete$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdDelete$Plain$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesIdDelete$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdDelete$Plain(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiClinicExerciseLibraryExercisesIdDelete$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesIdDelete$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdDelete$Json$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BooleanBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesIdDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesIdDelete$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesIdDelete$Json(params: {
    id: number;
  }): Observable<BooleanBaseResponse> {

    return this.apiClinicExerciseLibraryExercisesIdDelete$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanBaseResponse>) => r.body as BooleanBaseResponse)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesGet
   */
  static readonly ApiClinicExerciseLibraryExercisesGetPath = '/api/ClinicExerciseLibrary/exercises';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesGet$Plain$Response(params?: {
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
    name?: string;
    bodyPart?: string;
    equipment?: string;
    target?: string;
  }): Observable<StrictHttpResponse<ExerciseDtoPagedResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesGetPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
      rb.query('name', params.name, {});
      rb.query('bodyPart', params.bodyPart, {});
      rb.query('equipment', params.equipment, {});
      rb.query('target', params.target, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExerciseDtoPagedResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesGet$Plain(params?: {
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
    name?: string;
    bodyPart?: string;
    equipment?: string;
    target?: string;
  }): Observable<ExerciseDtoPagedResponse> {

    return this.apiClinicExerciseLibraryExercisesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ExerciseDtoPagedResponse>) => r.body as ExerciseDtoPagedResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesGet$Json$Response(params?: {
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
    name?: string;
    bodyPart?: string;
    equipment?: string;
    target?: string;
  }): Observable<StrictHttpResponse<ExerciseDtoPagedResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesGetPath, 'get');
    if (params) {
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
      rb.query('name', params.name, {});
      rb.query('bodyPart', params.bodyPart, {});
      rb.query('equipment', params.equipment, {});
      rb.query('target', params.target, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExerciseDtoPagedResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesGet$Json(params?: {
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
    name?: string;
    bodyPart?: string;
    equipment?: string;
    target?: string;
  }): Observable<ExerciseDtoPagedResponse> {

    return this.apiClinicExerciseLibraryExercisesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ExerciseDtoPagedResponse>) => r.body as ExerciseDtoPagedResponse)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesPost
   */
  static readonly ApiClinicExerciseLibraryExercisesPostPath = '/api/ClinicExerciseLibrary/exercises';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesPost$Plain$Response(params?: {
    body?: ExerciseDto
  }): Observable<StrictHttpResponse<ExerciseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExerciseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesPost$Plain(params?: {
    body?: ExerciseDto
  }): Observable<ExerciseDto> {

    return this.apiClinicExerciseLibraryExercisesPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ExerciseDto>) => r.body as ExerciseDto)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesPost$Json$Response(params?: {
    body?: ExerciseDto
  }): Observable<StrictHttpResponse<ExerciseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ExerciseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiClinicExerciseLibraryExercisesPost$Json(params?: {
    body?: ExerciseDto
  }): Observable<ExerciseDto> {

    return this.apiClinicExerciseLibraryExercisesPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ExerciseDto>) => r.body as ExerciseDto)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryStatusGet
   */
  static readonly ApiClinicExerciseLibraryStatusGetPath = '/api/ClinicExerciseLibrary/status';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryStatusGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryStatusGet$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryStatusGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryStatusGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryStatusGet$Plain(params?: {
  }): Observable<string> {

    return this.apiClinicExerciseLibraryStatusGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryStatusGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryStatusGet$Json$Response(params?: {
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryStatusGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryStatusGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryStatusGet$Json(params?: {
  }): Observable<string> {

    return this.apiClinicExerciseLibraryStatusGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation apiClinicExerciseLibraryExercisesTargetTargetMuscleGet
   */
  static readonly ApiClinicExerciseLibraryExercisesTargetTargetMuscleGetPath = '/api/ClinicExerciseLibrary/exercises/target/{targetMuscle}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Plain$Response(params: {
    targetMuscle: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesTargetTargetMuscleGetPath, 'get');
    if (params) {
      rb.path('targetMuscle', params.targetMuscle, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Plain(params: {
    targetMuscle: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Json$Response(params: {
    targetMuscle: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<StrictHttpResponse<Array<ExerciseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, ClinicExerciseLibraryService.ApiClinicExerciseLibraryExercisesTargetTargetMuscleGetPath, 'get');
    if (params) {
      rb.path('targetMuscle', params.targetMuscle, {});
      rb.query('limit', params.limit, {});
      rb.query('offset', params.offset, {});
      rb.query('sortMethod', params.sortMethod, {});
      rb.query('sortOrder', params.sortOrder, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ExerciseDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Json(params: {
    targetMuscle: string;
    limit?: number;
    offset?: number;
    sortMethod?: string;
    sortOrder?: string;
  }): Observable<Array<ExerciseDto>> {

    return this.apiClinicExerciseLibraryExercisesTargetTargetMuscleGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ExerciseDto>>) => r.body as Array<ExerciseDto>)
    );
  }

}
